export default "https://fiverr-res.cloudinary.com/npm-assets/@fiverr/search_perseus/apps/text_message_marketing.f84c7c4.svg";